import { Button, Drawer, FormManager, FormTextAreaInput, FormTextInput, Heading, HeadingRow, Timeline, TimelineItem } from "cai-fusion";
import { ReactComponent as IconCloseSquare } from "../../../images/close-square.svg";
import MDEditor from "@uiw/react-md-editor";
import { useMessages } from "../contexts/MessageContext";
import { useEffect, useState } from "react";
import { useTransientVisibility } from "../../fusion/Contexts/VisualContext";
import { useDataStore } from "../contexts/DataStoreContext";

const EditTextNoteDrawer = () => {

    const { visibilityStates, hide } = useTransientVisibility();
    const { textNote, setTextNote, newUploadTextNote, updateTextNote } = useDataStore();

    const handleSubmit = async () => {
        hide('EditTextNoteDrawer');
        if (textNote.isCreating) {
            newUploadTextNote();
        } else {
            updateTextNote();
        }
    }

    return (
        <Drawer
            clickOutsideToClose
            isHidden={!visibilityStates.EditTextNoteDrawer}
            placement='right' 
            onClose={() => hide('EditTextNoteDrawer')}
            header={
                <HeadingRow
                    size={3}
                    title="Text Note"
                    eyebrow="Data Collection"
                >
                    <div className="m-icon-row m-icon-row--right-align">
                        <a
                            href="#"
                            id="drawerCloseBtn"
                            className="a-icon m-icon-row__icon"
                            title="Close Associate Details"
                            onClick={() => hide('EditTextNoteDrawer')}
                        >
                            <IconCloseSquare className="a-icon-link__icon">
                                {" "}
                            </IconCloseSquare>
                        </a>
                    </div>
                </HeadingRow>
            }
            actions={
                <>
                    <Button
                        children="Cancel"
                        outline
                        onClick={() => hide('EditTextNoteDrawer')}
                    />
                    <Button
                        children={textNote.isCreating ? "Create" : "Save"}
                        onClick={handleSubmit}
                    />
                </>
            }
            id="folder-drawer"
            className="col-3 o-drawer--light-gray"
            children={
                <form className="o-form l-mt-sm">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
								<div className="col-12">
                                    <FormManager
                                        formObj={textNote}
                                        onInputChange={(fieldId, newValue) => setTextNote({...textNote, [fieldId]: newValue})}
                                    >
                                        <FormTextInput 
                                            displayName="Note Title"
                                            placeholder="New Text Note"
                                            fieldId="title"
                                        />
                                        <FormTextAreaInput 
                                            displayName="Note Content"
                                            fieldId="content"
                                            rows={15}
                                        />
                                    </FormManager>
								</div>
							</div>
                        </div>
                    </div>
                </form>
            }
        />
    )
}

export default EditTextNoteDrawer;